export const ENTITY_MEGA_HEADER = {
  POPULARITY_ICON_SIZE: 14,
  DESCRIPTION_TOOLTIP_WIDTH: 288,

  ENTITY_TYPES: {
    competition: "competition",
    competitor: "competitor",
  }
}